import { useEffect, useState } from "react";

interface WindowState {
  isMaximized: boolean;

  isMinimized: boolean;

  isVisible: boolean;

  bounds: { x: number; y: number; width: number; height: number };
}

interface ElectronAPI {
  minimizeWindow?: () => Promise<{ success: boolean; error?: string }>;

  toggleMaximizeWindow?: () => Promise<{ success: boolean; error?: string }>;

  closeWindow?: () => Promise<{ success: boolean; error?: string }>;

  getWindowState?: () => Promise<{
    success: boolean;

    state?: WindowState;

    error?: string;
  }>;

  onWindowStateChange?: (
    callback: (
      event: unknown,

      data: { isMaximized?: boolean; isMinimized?: boolean },
    ) => void,
  ) => void;
}

export const useWindowControls = () => {
  const [isMaximized, setIsMaximized] = useState(false);

  const [isMinimized, setIsMinimized] = useState(false);

  useEffect(() => {
    const electronAPI = window.electronAPI as unknown as ElectronAPI;

    if (electronAPI?.onWindowStateChange) {
      electronAPI.onWindowStateChange(
        (
          _event: unknown,

          data: { isMaximized?: boolean; isMinimized?: boolean },
        ) => {
          if (data.isMaximized !== undefined) {
            setIsMaximized(data.isMaximized);
          }

          if (data.isMinimized !== undefined) {
            setIsMinimized(data.isMinimized);
          }
        },
      );
    } else {
      console.warn("⚠️ electronAPI.onWindowStateChange not available");
    }
  }, []);

  const handleMinimize = async () => {
    console.log("🔽 handleMinimize called");

    try {
      const electronAPI = window.electronAPI as unknown as ElectronAPI;

      console.log("📱 electronAPI available:", !!electronAPI);

      console.log(
        "🔧 minimizeWindow function available:",

        !!electronAPI?.minimizeWindow,
      );

      if (electronAPI?.minimizeWindow) {
        console.log("⚡ Calling minimizeWindow...");

        const result = await electronAPI.minimizeWindow();

        console.log("📋 Minimize result:", result);

        if (!result.success) {
          console.error("Failed to minimize window:", result.error);
        }
      } else {
        console.warn("⚠️ minimizeWindow function not available");
      }
    } catch (error) {
      console.error("Error minimizing window:", error);
    }
  };

  const handleToggleMaximize = async () => {
    try {
      const electronAPI = window.electronAPI as unknown as ElectronAPI;

      if (electronAPI?.toggleMaximizeWindow) {
        const result = await electronAPI.toggleMaximizeWindow();

        if (!result.success) {
          console.error("Failed to toggle maximize window:", result.error);
        }
      }
    } catch (error) {
      console.error("Error toggling maximize window:", error);
    }
  };

  const handleClose = async () => {
    try {
      const electronAPI = window.electronAPI as unknown as ElectronAPI;

      if (electronAPI?.closeWindow) {
        const result = await electronAPI.closeWindow();

        if (!result.success) {
          console.error("Failed to close window:", result.error);
        }
      }
    } catch (error) {
      console.error("Error closing window:", error);
    }
  };

  return {
    isMaximized,

    isMinimized,

    handleMinimize,

    handleToggleMaximize,

    handleClose,
  };
};
